import { render } from "./ItemCodeView.vue?vue&type=template&id=65daec1a&ts=true"
import script from "./ItemCodeView.vue?vue&type=script&lang=ts"
export * from "./ItemCodeView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__